import { useState } from 'react'
import { observer } from 'mobx-react-lite'
import { Button } from 'shared/ui'
import { PresetContainer, PresetCard, PresetGrid, PresetFooter } from 'shared/Preset'
import { TemplateConfigList } from 'pages/workflows/ui/CreateWorkflowModal/config'
import {
  TemplateName,
  type ICreateWorkflowProps,
  type IWorkflowTemplateName,
} from 'pages/workflows/ui/CreateWorkflowModal/types/types'

import styles from './styles.module.scss'

export const WorkflowTemplateModal = observer(
  ({ workflow, onNext, onClose }: ICreateWorkflowProps) => {
    const [selectedTemplate, setSelectedTemplate] = useState<IWorkflowTemplateName>(
      TemplateName.FromScratch
    )

    const handleNext = () => {
      workflow.setTemplateName(selectedTemplate)
      onNext()
    }

    return (
      <PresetContainer>
        <PresetGrid>
          {TemplateConfigList.map((template) => (
            <PresetCard
              key={template.name}
              icon={template.icon}
              name={template.name}
              description={template.description}
              disabled={template.disabled}
              badge={template.disabled ? 'comingSoon' : undefined}
              selected={selectedTemplate === template.name}
              onClick={() => setSelectedTemplate(template.name)}
            />
          ))}
        </PresetGrid>
        <PresetFooter className={styles.footer}>
          <Button contained='secondary' text='Cancel' onClick={onClose} />
          <Button text='Next' onClick={handleNext} />
        </PresetFooter>
      </PresetContainer>
    )
  }
)
